import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { noop } from 'lodash';
import { COLORS } from 'Components/utils/color/colors';
import { Button } from 'Components/frameworks/button/Button';
export type MoreResultsProps = {
  className?: string;
  isLoading?: boolean;
  number: number;
  onClick?: (arg0: React.SyntheticEvent) => unknown;
  text?: string;
};
export const MoreResults = ({
  className,
  isLoading,
  number = 0,
  onClick = noop,
  text,
}: MoreResultsProps) => {
  if (!number) {
    return null;
  }

  return (
    <div className={classnames('flex w-full justify-center', className)}>
      <Button
        color={COLORS.SIENNA}
        colorBg={COLORS.TRANSPARENT}
        colorBorder={COLORS.SIENNA}
        data-testid="more-results-btn"
        isLoading={isLoading}
        onClick={onClick}
        size="medium"
      >
        <span data-testid="Moreresults-number">{number}</span> {text}
      </Button>
    </div>
  );
};
